/* eslint-disable import/prefer-default-export */
export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

export const accountTypes = [
  { name: 'Savings Account', title: 'Savings', id: 1 },
  { name: 'Current Account', title: 'Current', id: 2 },
  {
    name: 'Overdraft / Cash credit Account',
    title: 'Overdraft / Cash credit',
    id: 3
  }
];

export const genders = [
  { name: 'Male', title: 'Male' },
  { name: 'Female', title: 'Female' },
  { name: 'Other', title: 'Other' }
];

export const idType = [
  { name: 'PAN', title: 'PAN' },
  { name: 'Aadhaar', title: 'Aadhaar' },
  { name: 'Voter ID', title: 'Voter ID' },
  { name: 'Passport Number', title: 'Passport Number' },
  { name: 'Driving License', title: 'Driving License' }
];

export const addressTypes = [
  { name: 'Permanent Address', title: 'Permanent Address' },
  { name: 'Residence Address', title: 'Residence Address' },
  { name: 'Office Address', title: 'Office Address' },
  { name: 'Not Categorized', title: 'Not Categorized' },
  { name: 'Mortage Property Address', title: 'Mortage Property Address' }
];

export const creditBureaus = [
  {
    id: 12154,
    name: 'CIBIL',
    type: 'CONSUMER'
  },
  {
    id: 12251,
    name: 'CIBIL',
    type: 'COMMERCIAL'
  },
  {
    id: 12155,
    name: 'CRIF',
    type: 'CONSUMER'
  },
  {
    id: 12156,
    name: 'Equifax',
    type: 'CONSUMER'
  }
];
export const states = [
  { code: '01', title: 'Jammu & Kashmir', range: '180-194' },
  { code: '02', title: 'Himachal Pradesh', range: '171-177' },
  { code: '03', title: 'Punjab', range: '140-160' },
  { code: '04', title: 'Chandigarh', range: '160-160' },
  { code: '05', title: 'Uttaranchal/Uttarakhand', range: '244-263' },
  { code: '06', title: 'Haryana', range: '121-136' },
  { code: '07', title: 'Delhi', range: '110-110' },
  { code: '08', title: 'Rajasthan', range: '301-345' },
  { code: '09', title: 'Uttar Pradesh', range: '201-285' },
  { code: '10', title: 'Bihar', range: '800-855' },
  { code: '11', title: 'Sikkim', range: '737-737' },
  { code: '12', title: 'Arunachal Pradesh', range: '790-792' },
  { code: '13', title: 'Nagaland', range: '797-798' },
  { code: '14', title: 'Manipur', range: '795-795' },
  { code: '15', title: 'Mizoram', range: '796-796' },
  { code: '16', title: 'Tripura', range: '799-799' },
  { code: '17', title: 'Meghalaya', range: '793-794' },
  { code: '18', title: 'Assam', range: '781-788' },
  { code: '19', title: 'West Bengal', range: '700-743' },
  { code: '20', title: 'Jharkhand', range: '813-835' },
  { code: '21', title: 'Orissa', range: '751-770' },
  { code: '22', title: 'Chhattisgarh', range: '490-497' },
  { code: '23', title: 'Madhya Pradesh', range: '450-488' },
  { code: '24', title: 'Gujarat', range: '360-396' },
  { code: '25', title: 'Daman & Diu', range: '362-362' },
  {
    code: '26',
    title: 'Dadra & Nagar Haveli and Daman & Diu',
    range: '396-396'
  },
  { code: '27', title: 'Maharashtra', range: '400-445' },
  { code: '28', title: 'Andhra Pradesh', range: '500-535' },
  { code: '29', title: 'Karnataka', range: '560-591' },
  { code: '30', title: 'Goa', range: '403-403' },
  { code: '31', title: 'Lakshadweep', range: '682-682' },
  { code: '32', title: 'Kerala', range: '670-695' },
  { code: '33', title: 'Tamil Nadu', range: '600-643' },
  { code: '34', title: 'Pondicherry', range: '533-533' },
  { code: '35', title: 'Andaman & Nicobar Islands', range: '744-744' },
  { code: '36', title: 'Telangana', range: '500-509' },
  { code: '37', title: 'Ladakh', range: '194-194' }
];

export const message = {
  passwordUpdate: 'Password update successful. Sign in to continue.',
  createSuccess:
    'User added successfully. Email sent to user with login details.',
  editSuccess: 'Changes saved.',
  emailVerified: 'Your email was successfully verified! Sign in to continue.',
  resetInstruction:
    'Instructions to reset password sent to your email address.',
  passwordChanged: 'Password update successful!',
  reportCreate:
    'Report created successfully. Analysis may take one to five minutes depending on file size. You can check Analysis status below and use the Refresh button to get the latest status.',
  deleteReport: 'Report deleted successfully.',
  reportEdit: 'Report updated successfully.',
  planChange0:
    'Your plan selection has been saved. This change will take effect after remaining accounts in the current plan get used.',
  planChange:
    'Your plan selection has been saved. This change will take effect on subscription renewal date.',
  planChange1: 'Your subscription plan has been reverted.',
  methodSuccess: 'Payment method changed successfully.',
  primaryContactChanged: 'Primary contact changed successfully.',
  supportSuccess:
    'Your message has been sent successfully. We will get back to you within 24 hours.',
  contactUsSuccess:
    'Your message has been sent successfully. We will get back to you within 24 hours.',
  noTransaction: 'No matches found. ',
  accountNotVerified:
    'Your account is not verified. Go to your inbox and click the verification link to activate your Precisa account or get a new account verification link by clicking ',
  emailSent: 'Verification mail sent successfully.',
  emailAlready:
    'There is already a user with this email address. Try to register with different email address or click ',
  noSearchReports: 'No reports found.',
  noSearchUsers: 'No users found.',
  // noResultFound: 'No records found.',
  noResultFound: 'No data to display.',
  loginDetailsSent: 'Login details mail sent successfully.',
  extracting: 'Extracting Bank Account details...',
  extractingGst: 'Extracting GST Return details...',
  extractingCic: 'Extracting Credit report details...',
  gstr1DataError: 'No GSTR-1 data to display.',
  gstr2ADataError: 'No GSTR-2A data to display.',
  cyclicTransactionError: 'No cyclic transactions found.',
  noData: 'No data to display.'
};

export const errorMessage = {
  emailRequired: 'Email is required.',
  passwordRequired: 'Password is required.',
  invalidEmail: 'Invalid Email',
  invalidName: 'Enter a valid name. Only alphanumeric characters allowed.',
  passwordsDontMatch: "Passwords don't match.",
  passwordMustMatch: "Password and Confirm password don't match.",
  confirmPasswordRequired: 'Confirm password is required.',
  passwordLength: 'Password must be at least 8 characters.',
  fullNameRequired: 'Full name is required.',
  industryRequired: 'Industry is required.',
  industry1Required: 'Industry name is required.',
  paymentFail: 'Payment failed. Try again.',
  roleRequired: 'Role is required.',
  nameRequired: 'Name is required.',
  minDate: 'End date must be after start date.',
  bankNameCharLength: 'Bank name must be at most 300 characters.',
  accountStatusLength: 'Account status must be at most 100 characters.',
  bankNameRequired: 'Bank name is required.',
  accountTypeCharLength: 'Account type must be at most 300 characters.',
  accountTypeRequired: 'Account type is required.',
  accountNoRequired: 'Account number is required.',
  accountNoNotValid: 'Account number is not valid.',
  refIdNotValid: 'Only alphanumeric characters and underscore allowed.',
  refIdCharLength: 'Reference ID must be at most 300 characters.',
  reportNameRequired: 'Report name is required.',
  reportNameCharLength: 'Report name must be at most 300 characters.',
  phoneNumber: 'Phone number is required',
  invalidPhoneNumber: 'Enter a valid phone number.',
  companyName: 'Company name is required',
  messageRequired: 'Message is required.',
  subjectRequired: 'Subject is required.',
  companyRequired: 'Company name is required.',
  invalidPhoneNumberhas: 'Phone number has to be 10 digits.',
  invalidPhoneNumberInternational: 'Phone number is invalid',
  clientIdRequired: 'Client ID is required.',
  filepasswordRequired: 'Enter file password.',
  filepasswordIncorrect: 'Incorrect password. Try again.',
  invalidGstin: 'Enter a valid GSTIN.',
  invalidAddress:
    'Enter a valid address. Only alphanumeric characters allowed.',
  invalidCity: 'Enter a valid city.',
  invalidState: 'Enter a valid state.',
  invalidPincode: 'Enter a valid pin code.',
  gstinRequired: 'GSTIN is required.',
  addressRequired: 'Address is required.',
  cityRequired: 'City is required.',
  sityRequired: 'State is required.',
  pincodeRequired: 'Pin code is required.',
  invalidIfscCode: 'Enter a valid IFSC code.',
  invalidAccountStatus: 'Enter a valid Account status.',
  invalidMicrCode: 'Enter a valid MICR code.',
  invalidPanNumber: 'Enter a valid PAN number.',
  statementDateRequired:
    'Either start & end date both must be specified or both should be blank.',
  gstinError: 'Invalid GSTIN.',
  userNameRequired: 'GSTN username is required.',
  customerNameRequired: 'Customer name is required',
  customerNameCharLength: 'Customer name must be at most 300 characters.',
  otpRequired: 'OTP is required.',
  uploadFailed: 'Bank Account details mismatch.',
  reAnalysisMessage: 'No data to display. Click Refresh to re-run the report.',
  similarOperationForScore: `Can't apply similar operations filter for column Precisa score.`,
  invalidOtp: 'OTP is invalid.',
  otpRequired: 'OTP is required',
  reviewError: 'Form contains error. Check the fields highlighted in red.',
  customerIdCharLength: 'Customer ID must be at most 300 characters.',
  customerIdRequired: 'Customer ID is required.',
  captchaRequired: 'Captcha is required.',
  gstrErrorMessage:
    'This file will not be processed as it belongs to different GSTIN.',
  firstNameRequired: 'First name is required',
  middleNameRequired: 'Middle name is required',
  lastNameRequired: 'Last name is required',
  idNumberRequired: 'Id number is required',
  idTypeRequired: 'Id type is required',
  addressCategoryRequired: 'Address category is required',
  genderRequired: 'Gender is required',
  creditBureauRequired: 'Credit Bureau is required',
  creditBureauTypeRequired: 'Credit Bureau Report Type is required',
  consumerNameRequired: 'Consumer name is required',
  addressLine1Required: 'Address line 1 is required',
  addressLine2Required: 'Address line 2 is required',
  mobileRequired: 'Mobile number is required',
  dobRequired: 'Date of birth is required',
  invalidDOBFormat: 'Date of birth is invalid',
  cityRequired: 'City is required',
  pincodeRequired: 'Pincode is required',
  stateRequired: 'State is required',
  firstNameCharLength: 'First name must be at most 26 characters',
  middleNameCharLength: 'Middle name must be at most 26 characters',
  lastNameCharLength: 'Last name must be at most 26 characters',
  consumerNameCharLength: 'Consumer name must be at most 100 characters',
  idNumberCharLength: 'Id number must be at most 100 characters',
  addressLine1CharLength: 'Address line 1 must be at most 40 characters',
  addressLine2CharLength: 'Address line 2 must be at most 40 characters',
  cityCharLength: 'City must be at most 100 characters',
  mobileNumberCharLength: 'Mobile number must be at most 10 characters',
  pincodeCharLength: 'Pincode must be at most 6 characters',
  firstNameNotValid: 'First name is not valid.',
  middleNameNotValid: 'Middle name is not valid.',
  lastNameNotValid: 'Last name is not valid.',
  consumerNameNotValid: 'Consumer name is not valid.',
  cityNotValid: 'City is not valid.',
  mobileNoNotValid: 'Mobile number is not valid.',
  pincodeNotValid: 'pincode is not valid.',
  emptyFullName: 'Enter Full name',
  emptyEmail: 'Enter Email address',
  emptyPassword: 'Enter Password',
  emptyCompanyName: 'Enter Company name',
  emptyPhoneNumber: 'Enter Phone number'
};

export const confirmMessage = {
  cancelUser: 'Are you sure you want to cancel the operation?',
  cancelSignUp:
    'You will lose all your changes if you navigate away from this page. Are you sure you want to leave this page? Yes. No',
  saveChanges: 'Do you want to save your changes?',
  deleteReport:
    'This will permanently delete the report. Are you sure you want to continue?',
  cancelReport: 'Are you sure you want to cancel?',
  navigateReport: 'Are you sure you want to navigate away from this page?'
};

export const industryOptions = [
  'Lending',
  'Insurance',
  'Wealth management',
  'Other'
];

export const commonURL = 'api/v3/analysis';
export const commonLogURL = 'api/v3';
export const aggregateURL = '/api/v3/aggregate/analysis';
export const subscriptionURL = '/api/bsa/v3/subscription';
export const commonV2URL = '/api/bsa/v2';
export const commonV3URL = '/api/bsa/v3';
export const commonGstURL = '/api/gst/v1/analysis';
export const commonAggregateGstURL = '/api/gst/v1/aggregate';
export const commonGstURL1 = '/api/gst/v1';
export const commonBureauURL = '/api/creditbureau/v1';
export const commonCrossAnalysis = '/api/crossAnalysis/v1';

export const precisaScoreBankHelpText =
  'Precisa score denotes overall creditworthiness of the entity under review. This score is computed by Precisa’s proprietary algorithm based on various signals like irregular activities, OD/CC utilization, volatility etc., Computed score could range from 0-1000 where 1000 means “No risk” and 0-499 means “Moderate to High Risk"';
export const precisaScoreGstrHelpText =
  'Precisa score denotes overall creditworthiness of the entity under review. This score is computed by Precisa’s proprietary algorithm based on various signals like compliance rating, tax liability etc., Computed score could range from 0-1000 where 1000 means “No risk” and 0-499 means “Moderate to High Risk"';
export const precisaScoreCrossHelpText =
  'Precisa score denotes overall creditworthiness of the entity under review. This score is computed by Precisa’s proprietary algorithm based on various signals like irregular activities in Bank Account and GST Returns, OD/CC utilization, cash inflow/ outflow volatility, GSTR compliance rating, tax liability etc., Computed score could range from 0-1000 where 1000 means “No risk” and 0-499 means “Moderate to High Risk"';
export const volatilityHelpText =
  'Volatility score denotes the stability of inflow, outflow activities taking place in the account. Score ranges from 0-1 where 0 means account is very stable with consistent inflows and outflows. A score of 1 on the other hand means there are too many and inconsistent inflows and outflows i.e. the account fluctuates a lot.';

export const foirHelperText =
  'FOIR or the Fixed Obligations to Income Ratio is used to gauge a salaried borrower’s loan eligibility. It represents the portion of monthly income that is earmarked for repaying existing loans. It is calculated by dividing monthly loan repayments by salary, and averaging it for the bank statement period. Typically FOIR of 55% or below of below is considered low risk.';

export const activeBankAcountStatusHelpTextTitle = `Distribution of Active Bank Accounts by Account level Status. Here’s the definition of Account level status:`;

export const activeBankAcountStatusHelpTextList = [
  `1. Initialising - uploaded bank statement file(s) parsed and transaction data is being merged for Bank Account analysis. `,
  `2. Analysing - Bank Account analysis is in progress.`,
  `3. Analysed - CAM in progress. - Bank Accoount analysis completed and is available for viewing in the web application and can be retrieved by the API. Analysis is being exported to downloadable MS Excel file. `,
  `4. Analysed - CAM ready - analysis completed and is available for viewing in the web application and can be retrieved by the API. Analysis is also available for download in MS Excel file format.`,
  `5. Analysed - CAM failed - analysis completed and is available for viewing in the web application and can be retrieved by the API. Analysis export to downloadable MS Excel file format failed. `,
  `6. In review - unknown error encountered during Analysis and is being investigated. `,
  `7. Analysis on hold - Parsing errors encountered in uploaded file(s). Remove file or fix error for Analysis to proceed`
];

export const reportStatusTextTitle = `Report level status is computed by taking into consideration individual Bank Account level analysis status. `;

export const reportStatusTextList = [
  // `1. In progress – statements uploaded using API are in the process of being mapped to Bank Accounts, or Bank Accounts in mixed state like Initialising/ In review/ Analysing/ On Hold `,
  // `2. Analysed (X of Y Accounts) - when a subset of accounts are in “Analysed.” state and others are in Initialising/ Analysing/ In review/ On hold states`,
  // `2a. Account level analysis will be available in this scenario for accounts that are in Analysed state`,
  // `2b. Aggregate analysis across all accounts will be available only when all accounts are analysed`,
  // `3. Analysed (X Accounts) - CAM in progress - analysis completed for all accounts. Aggregate analysis completed and is available for viewing in the web application (in Report Dashboard view) and can be retrieved by the API. Aggregate analysis is being exported to downloadable MS Excel file`,
  // `4. Analysed (X Accounts) - CAM ready - analysis completed for all accounts. Aggregate analysis completed and is available for viewing in the web application (in Report Dashboard view) and can be retrieved by the API. Aggregate analysis is also available for download in MS Excel file format`,
  // `5. Analysed (X Accounts) - CAM failed - analysis completed for all accounts. Aggregate analysis completed and is available for viewing in the web application (in Report Dashboard view) and can be retrieved by the API. Analysis export to downloadable MS Excel file format failed. `,
  // `6. Analysis on hold - when all the accounts are in “Analysis on hold” state`
  `1. In Progress – account level analysis is in progress. Wait for analysis to complete.`,
  `2. Analysis on Hold – analysis paused due to account or file level errors. Fix errors to continue.`,
  `3. Analysed (X Accounts) – analysis ready for all accounts, use the left panel to navigate to different sections of the analysis.`,
  `4. Analysed (X of Y Accounts) – analysis ready for subset of the accounts. Use the left panel to view analysis (black labels) and identify accounts that have errors (grey labels). Fix errors in accounts on hold to complete the analysis.`,
  `5. CAM or Cross Analysis failed – contact support at bsacare@finezza.in for help.`
];

export const bankStatementFileStatusTitle = `Bank statement file status indicates if the file was parsed successfully or not. Here’s the definition of bank statement file level status displayed in saved Report and corrective action required for unblocking the analysis in case of parsing errors:`;

export const bankStatementFileStatusList = [
  `1. Initialising - preparing for parsing`,
  `2. Parsing - parsing has started`,
  `3. Parsed - file parsed successfully`,
  `4. In review - file can be parsed but needs manual intervention`,
  '5. Not parsable - file could not be parsed for some reason. Hover over the status to view reason and take appropriate corrective action'
];

export const gstFileStatusTitle =
  'File status indicates if the file was successfully parsed or not.';

export const gstFileStatusList = [
  '1. Initialising - preparing for parsing',
  '2. Parsing - parsing is in progress',
  '3. Parsed - file parsed successfully',
  '4. Failed - not GSTR-1 or GSTR-3B file',
  '5. Not parsable - file could not be parsed for some reason. Hover over the status to view reason and take appropriate corrective action',
  `6. In review - file can be parsed but needs manual intervention`
];

export const bureauFileStatusTitle =
  'File status indicates if the file was successfully parsed or not.';

export const bureauFileStatusList = [
  '1. Initialising - preparing for parsing',
  '2. Parsing - parsing is in progress',
  '3. Parsed - file parsed successfully',
  '4. Not parsable - file could not be parsed for some reason. Hover over the status to view reason and take appropriate corrective action',
  `5. In review - file can be parsed but needs manual intervention`
];

export const onlyAlphanumericRegex = /[^a-z0-9 ]/gi;

export const APIDOCSId = {
  name: 'Introduction',
  id: 'API_Introduction',
  item: [
    {
      id: 'API_Introduction_0',
      name: 'Introduction',
      static: true
    },
    {
      id: 'API_GatewayURL_0',
      name: 'API Gateway URL',
      static: true
    },
    {
      id: 'API_Integration_0',
      name: 'Integration',
      static: true
    },
    {
      id: 'API_ResoonseCodeStatus_0',
      name: 'Response Code Status',
      static: true
    },
    {
      id: 'API_PostManCollection_0',
      name: 'Postman Collection',
      static: true
    }
  ]
};

export const stateList = [
  { stateName: 'JAMMU AND KASHMIR', stateCode: '01' },
  { stateName: 'HIMACHAL PRADESH', stateCode: '02' },
  { stateName: 'PUNJAB', stateCode: '03' },
  { stateName: 'CHANDIGARH', stateCode: '04' },
  { stateName: 'UTTARAKHAND', stateCode: '05' },
  { stateName: 'HARYANA', stateCode: '06' },
  { stateName: 'DELHI', stateCode: '07' },
  { stateName: 'RAJASTHAN', stateCode: '08' },
  { stateName: 'UTTAR PRADESH', stateCode: '09' },
  { stateName: 'BIHAR', stateCode: '10' },
  { stateName: 'SIKKIM', stateCode: '11' },
  { stateName: 'ARUNACHAL PRADESH', stateCode: '12' },
  { stateName: 'NAGALAND', stateCode: '13' },
  { stateName: 'MANIPUR', stateCode: '14' },
  { stateName: 'MIZORAM', stateCode: '15' },
  { stateName: 'TRIPURA', stateCode: '16' },
  { stateName: 'MEGHALAYA', stateCode: '17' },
  { stateName: 'ASSAM', stateCode: '18' },
  { stateName: 'WEST BENGAL', stateCode: '19' },
  { stateName: 'JHARKHAND', stateCode: '20' },
  { stateName: 'ODISHA', stateCode: '21' },
  { stateName: 'CHATTISGARH', stateCode: '22' },
  { stateName: 'MADHYA PRADESH', stateCode: '23' },
  { stateName: 'GUJARAT', stateCode: '24' },
  {
    stateName: 'DADRA AND NAGAR HAVELI AND DAMAN AND DIU',
    stateCode: '26'
  },
  { stateName: 'MAHARASHTRA', stateCode: '27' },
  { stateName: 'ANDHRA PRADESH', stateCode: '28' },
  { stateName: 'KARNATAKA', stateCode: '29' },
  { stateName: 'GOA', stateCode: '30' },
  { stateName: 'LAKSHADWEEP', stateCode: '31' },
  { stateName: 'KERALA', stateCode: '32' },
  { stateName: 'TAMIL NADU', stateCode: '33' },
  { stateName: 'PUDUCHERRY', stateCode: '34' },
  { stateName: 'ANDAMAN AND NICOBAR ISLANDS', stateCode: '35' },
  { stateName: 'TELANGANA', stateCode: '36' },
  { stateName: 'ANDHRA PRADESH', stateCode: '37' },
  { stateName: 'LADAKH', stateCode: '38' }
];

export const pannyDrop = {
  '1': {
    color: 'success',
    label: 'Verified',
    heading: 'Penny Drop successful',
    description:
      'Bank Account authenticity was verified by depositing a small amount, called Penny Drop.'
  },
  '0': {
    color: 'error',
    label: 'Invalid',
    heading: 'Penny Drop failed',
    description:
      'Bank Account authenticity was verified by depositing a small amount, called Penny Drop.'
  },
  '2': {
    color: 'disable',
    label: 'Not verified',
    heading: 'Penny Drop not verified',
    description:
      'Bank Account authenticity is verified by depositing a small amount, called Penny Drop. This Bank Account could not be verified as Account Number and/or IFSC Code are missing. Enter these details under Report Settings and save report to verify the account.'
  }
};

export const panLabels = {
  '1': { color: 'success', label: 'Valid PAN' },
  '0': { color: 'error', label: 'Fake PAN' }
};

export const authenticityHelpText =
  'Precisa runs authenticity check on PDF file properties, format & content, to verify if the statement has been tampered with, and computes a Authenticity Rating as follows:';

export const authenticityHelpTextList = [
  'FRAUD CONFIRMED - Confirmed Tampering',
  'FRAUD SUSPECTED - User review recommended',
  'ORIGINAL - No Tampering',
  'UNKNOWN - Inconclusive results'
];
export const authenticityGstHelpText =
  'Precisa runs authenticity check to verify if the file has been tampered with and generates one of these statuses:';

export const authenticityGstHelpTextList = [
  'Fraud Confirmed – company name in the file doesn’t match with the company name obtained from GSTN Portal',
  'Original – company name in the file matched with the company name obtained from GSTN Portal',
  'Unknown – company name could not be verified'
];

export const authenticityBureauHelpText =
  'Precisa runs authenticity check on PDF file properties, format & content, to verify if the statement has been tampered with, and computes a Authenticity Rating as follows:';

export const authenticityBureauHelpTextList = [
  'FRAUD CONFIRMED - Confirmed Tampering',
  'REVIEW SUSPECTED - User review recommended',
  'ORIGINAL - No Tampering',
  'UNKNOWN - Inconclusive results'
];

export const initialSuspiciousCollapsesState = {
  ['Suspicious eStatements'.toLowerCase()]: false,
  ['ATM Withdrawals above 20,000'.toLowerCase()]: false,
  ['RTGS Payments below 2,00,000'.toLowerCase()]: false,
  ['Round Figure Tax Payments'.toLowerCase()]: false,
  ['Cheque deposits on bank holidays'.toLowerCase()]: false,
  ['Salary credits on bank holidays'.toLowerCase()]: false,
  ['Balance Mismatch'.toLowerCase()]: false,
  ['Negative balance'.toLowerCase()]: false,
  ['More cash deposits vs salary'.toLowerCase()]: false,
  ['Equal debits & credits'.toLowerCase()]: false,
  ['Immediate big debit after Salary credit'.toLowerCase()]: false,
  ['Salary Credit Amount remains unchanged over extended period'.toLowerCase()]: false,
  ['Parties present in both debits and credits'.toLowerCase()]: false,
  innerState: {
    ['Suspicious eStatements'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'fileName'
    },
    ['ATM Withdrawals above 20,000'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'date'
    },
    ['RTGS Payments below 2,00,000'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'date'
    },
    ['Round Figure Tax Payments'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'date'
    },
    ['Cheque deposits on bank holidays'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'date'
    },
    ['Salary credits on bank holidays'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'date'
    },
    ['Balance Mismatch'.toLowerCase()]: { order: 'desc', orderBy: 'date' },
    ['Negative balance'.toLowerCase()]: { order: 'desc', orderBy: 'date' },
    ['More cash deposits vs salary'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'month'
    },
    ['Equal debits & credits'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'month'
    },
    ['Immediate big debit after Salary credit'.toLowerCase()]: {
      order: 'asc',
      orderBy: 'month'
    },
    ['Salary Credit Amount remains unchanged over extended period'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'date'
    },
    ['Parties present in both debits and credits'.toLowerCase()]: {
      order: 'desc',
      orderBy: 'debitAmount'
    }
  }
};

export const gstMessage = {
  otpVerified: 'OTP verified',
  helpText:
    'GSTIN was successfully verified. Profile information associated with the GSTIN is displayed below.',
  loginSuccess:
    'GSTN Login successful. GSTR data retrieval and analysis can take up to 20 minutes. Save report to track progress and view analysis.',
  otpSent:
    ' OTP sent to [mobile]. OTP expires in [xx:xx]. Click Resend OTP if OTP is not received in 180 seconds.',
  otpExpired: 'OTP sent to [mobile] expired.',
  linkSent:
    'Login link will be sent to [email] and [mobile]. Link will expire in 24 hrs. Save Report to track progress and view analysis.',
  loginSuccessByLink:
    'Login successful. GSTR data retrieval is in progress and may take up to 20 minutes to complete.',
  loginMethodHelpText:
    'Make sure API access is enabled for this GSTIN in GST Portal before continuing. Click here to view the instructions for activating API access in GST Portal.'
};

export const errorDateMessage = 'Enter valid date.';

export const passwordLength = 'Password must be atleast 8 characters.';

export const errorDOBMessage = 'Enter valid date of birth.';

export const errorPincodeMessage = 'Enter valid pincode.';

export const errorCityMessage = 'Enter valid city.';

export const errorAddress1Message = 'Enter valid Address line 1.';

export const errorAddress2Message = 'Enter valid Address line 2.';

export const errorFirstNameMessage = 'Enter valid First name.';

export const errorMiddleNameMessage = 'Enter valid Middle name.';

export const errorLastNameMessage = 'Enter valid Last name.';

export const errorMobileMessage = 'Enter valid Mobile number.';

export const errorIdNumberLength = 'Enter valid Id Number.';

export const errorConsumerNameMessage = 'Enter valid Consumer name.';

export const monthlyPlanHelpText = `If actual usage exceeds this amount, the excess amount will be added to next month's invoice.`;

export const complianceHelpText =
  'Compliance Rating is a score given to a business to indicate how compliant they are in filing GST returns. This score ranges from 0 to 100 where 100 means the business is very compliant and a score closer to 0 means the business has defaulted in timely filing of returns. Parameters such as number of delays and number of days of delay are considered for computing the score.';

export const bankAccountUsedHelpText =
  'Number of Bank Accounts added to Reports for analysis, out of the Total Bank Accounts Subscribed. A value exceeding 100% indicates actual usage in excess of the subscribed number.';

export const bankAccountUsageHelpTextTitle = `This is the distribution of “Bank Accounts Subscribed” count by lifecycle status,`;

export const gstinUsageHelpTextTitle = `This is the distribution of “GST Accounts Subscribed” count by lifecycle status,`;

export const bureauReportsUsageHelpTextTitle = `This is the distribution of “Credit Bureau Reports Subscribed” count by lifecycle status,`;

export const bankAccountUsageHelpTextList = [
  '1. Active - Bank Accounts analysed and still live.',
  '2. Deleted - Bank Accounts deleted after analysis.',
  '3. Available - Bank Accounts that can be analysed before subscription expires.'
];

export const gstinUsageHelpTextList = [
  '1. Active - GST Accounts analysed and still live.',
  '2. Deleted - GST Accounts deleted after analysis.',
  '3. Available - GST Accounts that can be analysed before subscription expires.'
];

export const bureauReportsUsageHelpTextList = [
  '1. Active - Credit Bureau Reports analysed and still live.',
  '2. Deleted - Credit Bureau Reports deleted after analysis.',
  '3. Available - Credit Bureau Reports that can be analysed before subscription expires.'
];

export const minDate = 'To date must be after From date.';
export const camAlertMessage = ' to enable this feature.';
export const tryAfter = 'Please try again after 10 mins.';
export const invalidOtp = 'Invalid OTP.';

export const amlRickScoreHelper =
  'Anti Money Laundering (AML) Risk Score denotes the likelihood of the Bank Account being involved in money mule fraud. This score is computed by Precisa’s proprietary algorithm based on transaction patterns that are indicative of money laundering, for e.g., Big deposit followed by withdrawals on same or next day. Computed score could range from 0-100 where lower score means low risk and high score means high risk of money laundering.';
